














import { Component, Vue, Prop, Ref } from "vue-property-decorator";

@Component
export default class Images extends Vue {
    @Prop({ required: true }) images!: Image[];

    count: number = 6;

    handleImageClicked(id: number) {
        // @ts-ignore
        this.$root.$refs?.imageSlider.open(id);
    }

    get computedImages() {
        return this.images.slice(0, this.count);
    }
}
